function getDayTabIndex(_ref) {
  var focusable = _ref.focusable,
      hasValue = _ref.hasValue,
      selected = _ref.selected,
      firstInMonth = _ref.firstInMonth;

  if (!focusable) {
    return -1;
  }

  if (hasValue) {
    return selected ? 0 : -1;
  }

  return firstInMonth ? 0 : -1;
}

export { getDayTabIndex };